/**
 * Domains feature hooks — React Query wrappers for CRUD operations.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { domainsApi } from './api'

export function useEngineDomains(params?: any) {
    return useQuery({
        queryKey: ['domains', params],
        queryFn: async () => {
            const res = await domainsApi.getAll(params)
            return res.data
        },
    })
}

export function useCreateEngineDomain() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (data: any) => domainsApi.create(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['domains'] })
        },
    })
}

export function useUpdateEngineDomain() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: any }) => domainsApi.update(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['domains'] })
        },
    })
}

export function useDeleteEngineDomain() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => domainsApi.delete(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['domains'] })
        },
    })
}

